import { Search } from '@snack-uikit/search';
import cn from 'classnames';

import { PlatformSelect } from '../../../../../snack/components/PlatformSelect';
import { SectionCatalogSearchItem } from '../../types';
import s from './styles.module.scss';

export function SectionCatalogSearch({
  platformFilter,
  onPlatformFilterChange,
  platforms,
  handleFocusSearch,
  handleChangeFilter,
  titleFilter,
}: SectionCatalogSearchItem) {
  return (
    <div className={s.searchComponentWrapper}>
      <div className={s.menu}>
        <PlatformSelect
          platforms={platforms}
          value={platformFilter}
          onChange={onPlatformFilterChange}
        />
      </div>
      <div className={s.searchInput}>
        <Search
          className={cn(s.search, s.border)}
          placeholder="Поиск продукта"
          size="l"
          value={titleFilter}
          onChange={handleChangeFilter}
          onFocus={handleFocusSearch}
        />
      </div>
    </div>
  );
}
